/* @flow */
import React, { Component } from 'react';

import cx from 'classnames';
import styles from './styles/TopicsSectionTitle.css';

export class TopicsSectionTitle extends Component {
  static propTypes = {
    children: React.PropTypes.node.isRequired,
  };

  render() {
    return (
      <h3 className={cx(this.props.className, styles.this)}>
        {this.props.children}
      </h3>
    );
  }
}

export default TopicsSectionTitle;



// WEBPACK FOOTER //
// ./src/groups/components/TopicsSectionTitle.jsx